/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { killswitchesList } from "../funcs/killswitchesList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { KillswitchCapabilityKey } from "../models/components/killswitchcapabilitykey.js";
import { KillswitchListStatus } from "../models/components/killswitchliststatus.js";
import {
  KillswitchesListRequest,
  KillswitchesListResponse,
  KillswitchesListSecurity,
} from "../models/operations/killswitcheslist.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type KillswitchesQueryData = KillswitchesListResponse;

export type KillswitchesInfiniteQueryData = PageIterator<
  KillswitchesListResponse,
  { cursor: string }
>;

export type KillswitchesPageParams = PageIterator<
  KillswitchesListResponse,
  { cursor: string }
>["~next"];

export function prefetchKillswitches(
  queryClient: QueryClient,
  client$: GramCore,
  security: KillswitchesListSecurity,
  request?: KillswitchesListRequest | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildKillswitchesQuery(
      client$,
      security,
      request,
      options,
    ),
  });
}

export function prefetchKillswitchesInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  security: KillswitchesListSecurity,
  request?: KillswitchesListRequest | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildKillswitchesInfiniteQuery(
      client$,
      security,
      request,
      options,
    ),
    initialPageParam: undefined as KillswitchesPageParams,
    getNextPageParam: (previousPage: KillswitchesInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildKillswitchesQuery(
  client$: GramCore,
  security: KillswitchesListSecurity,
  request?: KillswitchesListRequest | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<KillswitchesQueryData>;
} {
  return {
    queryKey: queryKeyKillswitches({
      capabilityKey: request?.capabilityKey,
      userId: request?.userId,
      status: request?.status,
      limit: request?.limit,
      cursor: request?.cursor,
      gramSession: request?.gramSession,
    }),
    queryFn: async function killswitchesQueryFn(
      ctx,
    ): Promise<KillswitchesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(killswitchesList(
        client$,
        security,
        request,
        mergedOptions,
      ));
    },
  };
}

export function buildKillswitchesInfiniteQuery(
  client$: GramCore,
  security: KillswitchesListSecurity,
  request?: KillswitchesListRequest | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, KillswitchesPageParams>,
  ) => Promise<KillswitchesInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyKillswitchesInfinite({
      capabilityKey: request?.capabilityKey,
      userId: request?.userId,
      status: request?.status,
      limit: request?.limit,
      cursor: request?.cursor,
      gramSession: request?.gramSession,
    }),
    queryFn: async function killswitchesQuery(
      ctx,
    ): Promise<KillswitchesInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(killswitchesList(
          client$,
          security,
          request,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(killswitchesList(
        client$,
        security,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyKillswitches(
  parameters: {
    capabilityKey?: KillswitchCapabilityKey | undefined;
    userId?: string | undefined;
    status?: KillswitchListStatus | undefined;
    limit?: number | undefined;
    cursor?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "killswitches", "list", parameters];
}

export function queryKeyKillswitchesInfinite(
  parameters: {
    capabilityKey?: KillswitchCapabilityKey | undefined;
    userId?: string | undefined;
    status?: KillswitchListStatus | undefined;
    limit?: number | undefined;
    cursor?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "killswitches", "list", "infinite", parameters];
}
